"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Filter_1 = __importDefault(require("../Filter"));
var DetailFilterComponent = function (_a) {
    var grid = _a.grid, name = _a.name, _b = _a.className, className = _b === void 0 ? 'col-sm-6 col-md-4 col-lg-3 form-group filter-element' : _b, children = _a.children, _c = _a.withDetailFilter, withDetailFilter = _c === void 0 ? false : _c;
    return withDetailFilter
        &&
            react_1["default"].createElement(Filter_1["default"], { name: name, className: className, grid: grid }, children);
};
exports["default"] = DetailFilterComponent;
